/* eslint-disable max-len, i18next/no-literal-string */
import React from 'react';

export function HandShoppingBag(): JSX.Element {
  return (
    <svg width='43' height='39' viewBox='0 0 43 39' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.58579 26.4142L2.41421 27.5858C1.63317 28.3668 1.63316 29.6332 2.41421 30.4142L8.58579 36.5858C9.36683 37.3668 10.6332 37.3668 11.4142 36.5858L12.5858 35.4142C13.3668 34.6332 13.3668 33.3668 12.5858 32.5858L6.41421 26.4142C5.63316 25.6332 4.36684 25.6332 3.58579 26.4142Z'
        stroke='#153F66'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M13.5 20V3C13.5 1.89543 14.3954 1 15.5 1H32.5C33.6046 1 34.5 1.89543 34.5 3V18'
        stroke='#FF3E51'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path d='M18.5 6.5H20.5' stroke='#FF3E51' strokeWidth='2' strokeLinecap='round' />
      <path
        d='M19.4995 6.5C19.3328 8.66667 19.9995 13 23.9995 13C27.9995 13 28.6662 8.66667 28.4995 6.5'
        stroke='#FF3E51'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path d='M27.5 6.5H29.5' stroke='#FF3E51' strokeWidth='2' strokeLinecap='round' />
      <path
        d='M21 25H28.5C29.6046 25 30.5 24.1046 30.5 23V23M30.5 23V22.5C30.5 21.3954 29.6055 20.5 28.5009 20.5C23.2427 20.5 14.9573 20.5 12.5 20.5C10.4135 20.5 8.01243 22.6285 6.57934 24.1961C5.91967 24.9177 6.0067 26.0067 6.69802 26.698L11.6904 31.6904C12.4294 32.4294 13.6127 32.4748 14.4062 31.7947L15.9383 30.4815C16.3008 30.1708 16.7624 30 17.2398 30H29.6716C30.202 30 30.7107 29.7893 31.0858 29.4142L41.0858 19.4142C41.8668 18.6332 41.8668 17.3668 41.0858 16.5858L40.4142 15.9142C39.6332 15.1332 38.3668 15.1332 37.5858 15.9142L30.5 23Z'
        stroke='#153F66'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
}
